import * as net from 'util/Net';

// Keep in sync with BearerTokenConsumer in auth/api/tokens.py
export enum BearerTokenConsumer {
  MOBILE = 'MOBILE',
  ASSAYS = 'ASSAYS',
  API_SUPPORT_ACCESS = 'API_SUPPORT_ACCESS',
  V3_EXPLORER = 'V3_EXPLORER',
}

export interface CreateBearerTokenParams {
  bearerTokenConsumer: BearerTokenConsumer;
}

export interface CreateBearerTokenResponse {
  access_token: string;
  token_type: string;
  /**
   * @unit seconds
   */
  expires_in: number;
}

export function getBearerToken(data: CreateBearerTokenParams): Promise<CreateBearerTokenResponse> {
  return net.postJSONPromise({url: '/1/api/bearer-token:create', data});
}
